import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

function CardPreview({ card, height = 200 }) {
  // Fonction pour obtenir l'URL complète des images
  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return null;
    const baseUrl = process.env.REACT_APP_API_URL.replace(/\/api$/, '');
    return `${baseUrl}${imageUrl}`;
  };

  return (
    <Box 
      sx={{ 
        height,
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: 1,
        backgroundColor: 'transparent',
        display: 'flex',
        overflow: 'hidden'
      }}
    >
      {/* Face avant */}
      <Box 
        sx={{ 
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2
        }}
      >
        {card.frontImageUrl && (
          <Box
            component="img"
            src={getImageUrl(card.frontImageUrl)}
            alt=""
            sx={{
              maxWidth: '100%',
              maxHeight: '60%',
              objectFit: 'contain',
              mb: 1
            }}
          />
        )}
        <Typography 
          variant="body2" 
          align="center"
          sx={{ 
            color: card.frontColor,
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap',
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical'
          }}
        >
          {card.front}
        </Typography>
      </Box>

      {/* Séparateur vertical */}
      <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

      {/* Face arrière */}
      <Box 
        sx={{ 
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2
        }}
      >
        {card.backImageUrl && (
          <Box
            component="img"
            src={getImageUrl(card.backImageUrl)}
            alt=""
            sx={{
              maxWidth: '100%',
              maxHeight: '60%',
              objectFit: 'contain',
              mb: 1
            }}
          />
        )}
        <Typography 
          variant="body2" 
          align="center"
          sx={{ 
            color: card.backColor,
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap',
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical'
          }}
        >
          {card.back}
        </Typography>
      </Box>
    </Box>
  );
}

export default CardPreview; 